export const iconFontAwesomeUsersPeopleUserGroup = (
	<i className="fa-solid fa-user-group"></i>
);
